import { queryAccountEligibility } from '../api/queryAccountEligibility'
import { queryCardDetail } from '../api/queryCardDetail'
import { LinkType } from '../types'
import { getCardStatus } from './getCardStatus'

type DecideLinkType = (params: {
  isDebitCardAccountType: boolean
  accountId: string
}) => Promise<LinkType>

export const decideLinkType: DecideLinkType = async ({
  isDebitCardAccountType,
  accountId,
}) => {
  if (!isDebitCardAccountType) {
    return { tag: 'none' }
  }

  try {
    const { eligible, cardEligible, custCardId } =
      await queryAccountEligibility({ accountId })

    if (eligible && cardEligible === 'new') return { tag: 'order' }

    if (custCardId) {
      const { statusDetails, isCardEmbossed, lastFourDigits } =
        await queryCardDetail({
          custCardId,
        })

      const cardStatus = getCardStatus({ statusDetails, isCardEmbossed })
      if (cardStatus === 'hidden') {
        return { tag: 'none' }
      }
      return {
        tag: 'manage',
        lastFourDigits,
        custCardId,
      }
    }
  } catch {
    return { tag: 'none' }
  }
  return { tag: 'none' }
}
